//
//  ElementDataViewColumn.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Definitions
export var ElementDataViewColumnType;
(function (ElementDataViewColumnType) {
    ElementDataViewColumnType["baseProperty"] = "BaseProperty";
    ElementDataViewColumnType["propertyDefinition"] = "PropertyDefinition";
    ElementDataViewColumnType["theme"] = "Theme";
})(ElementDataViewColumnType || (ElementDataViewColumnType = {}));
export var ElementDataViewColumnBasePropertyType;
(function (ElementDataViewColumnBasePropertyType) {
    ElementDataViewColumnBasePropertyType["name"] = "Name";
    ElementDataViewColumnBasePropertyType["description"] = "Description";
    ElementDataViewColumnBasePropertyType["value"] = "Value";
    ElementDataViewColumnBasePropertyType["updatedAt"] = "UpdatedAt";
})(ElementDataViewColumnBasePropertyType || (ElementDataViewColumnBasePropertyType = {}));
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class ElementDataViewColumn {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b, _c;
        this.id = model.id;
        this.persistentId = model.persistentId;
        this.type = model.type;
        this.basePropertyType = (_a = model.basePropertyType) !== null && _a !== void 0 ? _a : null;
        this.propertyDefinitionId = (_b = model.propertyDefinitionId) !== null && _b !== void 0 ? _b : null;
        this.themeId = (_c = model.themeId) !== null && _c !== void 0 ? _c : null;
        this.width = model.width;
    }
}
